module.exports = __webpack_public_path__ + "img/locker.243ebf78.gif";